import gameInfo from '../assets/json/gameInfo.json'
import Phaser from 'phaser';
import gameData from './gameData.js';
import FontKeys from './FontKeys';
import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';

const fonts = [];
for (let k in FontKeys) {
  fonts.push(FontKeys[k]);
}

// note: uncomment or change the following based on what you need to load
ABCyaPhaser.Preloader.PreloaderConfig.fonts = fonts;
/**
 * To load multiple image sprites, change this property to an array of Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig objects.
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.imagesPath = [
 * { key: ABCyaPhaser.Images.DEFAULT_ATLAS, atlasURL: 'assets/images/' + ABCyaPhaser.Images.DEFAULT_ATLAS + '.json', path: 'assets/images' }, // default multiatlas
 * { key: "particles", atlasURL: 'assets/images/particles.json', path: 'assets/images' }
 * ]
 */
ABCyaPhaser.Preloader.PreloaderConfig.imagesPath = 'assets/images';
/**
 * To load multiple audio sprites, change this property to an array of Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig objects.
 * Note: you should always include an ogg and mp3 file, the game will determine which to use based on compatibility. 
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.soundsPath = [
 * { key: ABCyaPhaser.Audio.DEFAULT_AUDIO_SPRITE, 
 *   jsonURL: 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.json', 
 *   audioURL: [ 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.ogg', 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.mp3' ] }, // default sound sprite
 * { key: "extrasounds", jsonURL: 'assets/sounds/extrasounds.json', audioURL: [ 'assets/sounds/extrasounds.ogg', 'assets/sounds/extrasounds.mp3' ] }
 * ]
 */
ABCyaPhaser.Preloader.PreloaderConfig.soundsPath = 'assets/sounds';
/**
 * You can load spine objects here. This can be an object with key, jsonPath, and atlasPath properties, or an array of those objects.
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.spines = [
 * { key: "spine0", jsonPath: "assets/spines/spine0.json", atlasPath: "assets/spines/spine0.atlas" },
 * { key: "spine1", jsonPath: "assets/spines/spine1.json", atlasPath: "assets/spines/spine1.atlas" }
 * ]
 */
//ABCyaPhaser.Preloader.PreloaderConfig.spines = { key: "", jsonPath: "", atlasPath: "" };

ABCyaPhaser.Preloader.PreloaderConfig.startScene = gameData.startScene;

/**
 * Called when the preload function is done.
 * @param {Phaser.Scene} scene the preloader scene
 */
ABCyaPhaser.Preloader.PreloaderConfig.preloadCallback = scene => {
  if (gameData.isAlphabet) {
    // load alphabet data
    scene.load.json("alphabet", "assets/levels/alphabet/dot-data.json");
    scene.load.once(Phaser.Loader.Events.FILE_KEY_COMPLETE + "json-alphabet", () => {
      // load the image(s) associated with this json
      let levelPuzzles = scene.cache.json.get("alphabet").puzzles;
      for (let i = 0; i < levelPuzzles.length; i++) {
        scene.load.image("alphabetpuzzleFinal" + (i + 1), "assets/levels/alphabet/Puzzle" + (i + 1) + "Final.png");
      }
    });
  }
  else {
    // load the json files for the level data
    let manifest = [
      { id: "level1", src: "assets/levels/level1/" + "dot-data.json" },
      { id: "level2", src: "assets/levels/level2/" + "dot-data.json" },
      { id: "level3", src: "assets/levels/level3/" + "dot-data.json" },
      { id: "level4", src: "assets/levels/level4/" + "dot-data.json" },
      { id: "level5", src: "assets/levels/level5/" + "dot-data.json" },
      { id: "level6", src: "assets/levels/level6/" + "dot-data.json" },
      { id: "level7", src: "assets/levels/level7/" + "dot-data.json" },
      { id: "level8", src: "assets/levels/level8/" + "dot-data.json" },
      { id: "level9", src: "assets/levels/level9/" + "dot-data.json" },
      { id: "level10", src: "assets/levels/level10/" + "dot-data.json" }
    ];
    manifest.forEach(m => {
      scene.load.json(m.id, m.src);
      scene.load.once(Phaser.Loader.Events.FILE_KEY_COMPLETE + "json-" + m.id, () => {
        // load the image(s) associated with this json
        let levelPuzzles = scene.cache.json.get(m.id).puzzles;
        for (let i = 0; i < levelPuzzles.length; i++) {
          scene.load.image(m.id + "puzzleFinal" + (i + 1), "assets/levels/" + m.id + "/final_images/Puzzle" + (i + 1) + "Final.png");
        }
      });
    });
  }
}

(async function handshake() {
  try {
    await ABCyaLib.Environment.instance.doParentHandshake();
  } catch (error) {
    console.warn(error);
  }

  const config = ABCyaLib.getConfig();
  if (config.gameShortName !== null && typeof config.gameShortName === 'string' && config.gameShortName.length > 0) {
    // eslint-disable-next-line no-undef
    switch (config.gameShortName) {
      case 'connect_the_dots':
        gameData.isAlphabet = false;
        break;
      case 'connect_the_dots_abc_order':
        gameData.isAlphabet = true;
        break;
    }
  }

  console.info("ABCya Game Info:", gameInfo);

  /**
   * Use the fourth argument of initializePhaserGame to override default Phaser config options
   * For example: to use the Spine plugin, the fourth argument should look like this:
   * { 
          configOverrides: {
              plugins: {
                  scene: [
                      { key: 'SpinePlugin', plugin: window.SpinePlugin, mapping: 'spine' }
                  ]
              }
          }
      }
   */
  ABCyaPhaser.Misc.initializePhaserGame(1024, 768, gameData.scenes);

  // initialize any functionality in abcya_phaser that has a dependency on abcya_lib 
  ABCyaPhaser.Misc.initializeAbcyaLibDependencies(ABCyaLib);
})();
